import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const EquipeSection = () => {
  const { t } = useTranslation("informations/EquipeSection");

  return (
    <Box sx={{ display: "flex", justifyContent: "center", px: 2, mt: 10, mb: 10 }}>
      <Box
        sx={{
          maxWidth: "1000px",
          width: "100%",
          fontFamily: "'Poppins', sans-serif",
          textAlign: "center",
        }}
      >
        {/* Titre */}
        <Typography
          sx={{
            fontWeight: 900,
            fontSize: { xs: "2.2rem", md: "3rem" },
            color: "#000",
            mb: 1,
          }}
        >
          {t("title.part1")}{" "}
          <Box component="span" sx={{ color: "#449F2D" }}>
            {t("title.highlight")}
          </Box>{" "}
          {t("title.part2")}
        </Typography>

        {/* Sous-titre */}
        <Typography
          sx={{
            fontSize: "1rem",
            color: "#666",
            maxWidth: "700px",
            mx: "auto",
            mb: 4,
          }}
        >
          {t("subtitle")}
        </Typography>

        {/* Paragraphe principal */}
        <Typography
          sx={{
            fontSize: "1.1rem",
            fontWeight: 400,
            color: "#444",
            lineHeight: 1.8,
            maxWidth: "800px",
            mx: "auto",
          }}
        >
          {t("lede.a")}{" "}
          <Box component="span" fontWeight="bold">{t("lede.brand")}</Box>
          {t("lede.b")}{" "}
          {t("lede.c")}{" "}
          <Box component="span" fontWeight="bold">{t("lede.protectCyclists")}</Box>
          {t("lede.d")}{" "}
          <Box component="span" fontWeight="bold">{t("lede.sustainableMobility")}</Box>
          {t("lede.e")}{" "}
          <Box component="span" fontWeight="bold">{t("lede.humanSimpleReactive")}</Box>
          {t("lede.f")}
        </Typography>
      </Box>
    </Box>
  );
};

export default EquipeSection;